export default __webpack_public_path__ + "static/media/landing.8150f1b0.jpg";